<template>
    <div class="w-full flex flex-column gap-1">
        <div class="p-inputgroup w-full cur_drop flex flex-row" style="min-height: 64px;">
            <Dropdown v-if="amount_array && amount_array.length>0" v-model="amount_selected" :options="amount_array"
                option-label="name" class='flex flex-1 border-2 surface-border border-right-none border-round-left-2xl w-9rem p-inputtext-xl text-xl font-medium align-items-center text-700'
                :placeholder="lang('select_currency')">
            </Dropdown>

            <InputGroup v-else>
                <InputNumber :placeholder="lang('amount')" v-model="amountFormat" inputId="locale-us"
                    class="flex flex-1 border-2 border-round-lg surface-border amount_input overflow-hidden"
                    :disabled="disableInput" size="large"
                    :min-fraction-digits="0" :max-fraction-digits="digits" :min="min" :max="max" />
                <InputGroupAddon v-if="isClearButtons" class="border-top-2 border-bottom-2 px-1" style="border-start-end-radius:0!important;border-end-end-radius:0!important;border-right:0!important;min-width:none;">
                    <i v-if="true" class="pi pi-times p-0 surface-0 border-circle cursor-pointer" @click="clear()" />
                    <i v-else class="pi pi-clipboard p-1 surface-0 border-circle cursor-pointer" @click="past('send', min, max)"/>
                </InputGroupAddon>
            </InputGroup>

            <div class="flex p-inputgroup-addon p-0 border-2 border-left-none surface-border align-items-center px-2" :class="(disableSelect) ? 'surface-100' : 'surface-0'">
                <Button v-if="currency" @click="openPopup" :label="currency.code" severity="info" outlined :disabled="disableSelect"
                    :class="(!disableSelect) ? 'surface-50' : 'surface-0'"
                    class="flex border-none border-300 border-round-2xl text-600 font-medium uppercase pl-1" 
                    style="min-width: 4rem;border-radius:100px!important;">
                        <AvatarGroup v-if="currency.image">
                            <Avatar :image="currency.image" shape="circle" class="mr-1 border-none"/>
                        </AvatarGroup>
                        <i v-else class="pi pi-question-circle mr-1"></i>
                        <span class="uppercase">{{ currency.code }}</span>
                        <i class="pi pi-chevron-right"></i>
                </Button>
            </div>
        </div>
        <span v-if="(min || max) && !disableInput && !amount_selected" class="w-full flex flex-row text-500 text-xs gap-1"> 
            <span v-if="min" class="flex text-primary cursor-pointer" @click="setMin">min</span>
            <span v-if="min && max && currency" class="flex">{{ splitNum(min) }} – {{ splitNum(max) }} {{getCurSign(currency)}} </span>
            <span v-if="max" class="flex text-primary cursor-pointer" @click="setMax">max</span>
        </span>
    </div>
    <Dialog v-model:visible="popup" modal
        class="w-full border-round-xl overflow-hidden border-none surface-100"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', margin: '0!important', padding: '0!important'} : { width: 'auto', height: '100%' }" 
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: '100%' }"
        :class="(screenSize=='xs') ? 'border-noround-bottom h-full' : 'max-w-30rem'">

        <template #header>
            <span class="text-lg font-medium">{{ lang(currencyTitleKey) }}</span>
        </template>

        <div class="w-full flex flex-column gap-5" style="min-height:300px">
            <div v-if="currencies.length" class="flex flex-column gap-3 xl:py-4 xl:px-1 lg:py-3 md:py-2">
                <MobMenu>
                    <template v-slot:body>
                        <div v-for="curr of filteredCurrencies" @click="setCurrency(curr)"
                            class="w-full relative flex flex-row gap-2 px-3 py-2 border-100 cursor-pointer border-bottom-1" style="min-height:65px">
                            <div class="flex flex-row flex-1 gap-3">
                                <div v-if="curr.image" class="flex align-items-center">
                                    <AvatarGroup>
                                        <Avatar :image="getCurImage(curr)" class="surface-0 border-100" shape="circle"/>
                                    </AvatarGroup>
                                </div>
                                <div class="flex-1 flex flex-column gap-1 justify-content-center">
                                    <div class="w-full flex flex-column gap-1 overflow-hidden white-space-nowrap align-items-start font-medium text-sm xl:text-md" >
                                        <span class="uppercase">
                                            {{ curr.code }}
                                        </span>
                                        <span v-if="curr.titles && curr.titles[lang_] && curr.sign" class="text-500">
                                            {{ curr.titles[lang_] }}, {{ curr.sign }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="absolute right-0 top-0 bottom-0 flex justify-content-center align-items-center mr-3">
                                <div class="surface-border border-1 border-circle surface-0 deep_white_shadow">
                                    <div class="border-circle" style="width:18px;height:18px;margin:3px" :class="{'bg-green-400 surface-0': curr.code==currency.code}"></div>
                                </div>
                            </div>
                        </div>
                    </template>
                </MobMenu>
            </div>
        </div>

        <template #footer>
            <div class="w-full flex flex-column gap-2">
                <div v-if="isSearchable" class="w-full flex pt-3">
                    <InputGroup class="w-full">
                        <InputText v-model="searchStr" size="large" :placeholder="content[lang_].search_placeholder"
                            class="w-full flex border-2 border-300 border-round-left-xl border-right-none" />
                        <InputGroupAddon class="border-2 border-300 border-round-right-xl border-left-none">
                            <i class="pi pi-search"></i>
                        </InputGroupAddon>
                    </InputGroup>
                </div>
                <div v-if="isRequest" class="flex flex-column gap-2 w-full pt-2 text-center">
                    <span class="flex text-sm text-600">
                        {{ content[lang_].msg }}
                    </span>
                    <Button :label="content[lang_].btn" @click="goToRequest()" class="w-full surface-0 border-none border-round-2xl text-primary font-medium text-base" size="large"/>
                </div>
            </div>
        </template>
    </Dialog>
</template>

<script>
import MobMenu from '@/components/sides/menu/MobMenu.vue'
import BigNumber from 'bignumber.js'
import Helper from '@/assets/js/Helper.js'

export default {
	name: 'InputAmount',
    props: {
        amount: {
            type: Number,
            default: null
        },
        amount_array: {
            type: Object,
            default: () => []
        },
        amount_array_selected: {
            type: Object,
            default: () => []
        },
        currency: {
            type: Object,
            required: true
        },
        currencies: {
            type: Array,
            default: () => []
        },
        min: {
            type: Number,
            default: 0
        },
        max: {
            type: Number,
            default: null
        },
        disableInput: {
            type: Boolean,
            default: false
        },
        disableSelect: {
            type: Boolean,
            default: false
        },
        digits: {
            type: Number,
            default: 2
        },
        isClearButtons: {
            type: Boolean,
            default: true
        },
        isRequest: {
            type: Boolean,
            default: false
        },
        isSearchable: {
            type: Boolean,
            default: false
        },
        currencyTitleKey: {
            type: String,
            default: 'currency_send'
        },
    },
	data() {
		return {
            popup: false,
            searchStr: '',
            content: {
                en: {
                    msg: "Need a currency that's not listed? Create a transfer request and we'll help you with the transfer.",
                    btn: "Transfer Request",
                    search_placeholder: "Search",
                },
                ru: {
                    msg: "Нет нужной валюты? Создайте заявку и мы поможем осуществить нужный перевод.",
                    btn: "Заявка на перевод",
                    search_placeholder: "Поиск",
                }
            },
            amount_selected: null,
        }
    },
    components: {
        MobMenu,
    },
    watch: {
        amount_array_selected(newVal) {
            this.amount_selected = newVal;
        },
        amount_selected(newVal) {
            this.$emit('update:amount_array_selected', newVal);
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru'},
        screenSize() { return this.$store.getters.StateScreenSize },
        amountFormat: {
            get() {
                return this.amount;
            },
            set(value) {
                this.$emit('update:amount', value);
            }
        },
        filteredCurrencies() {
            if (!this.searchStr || this.searchStr.trim() === '') {
                return this.currencies
            }
            
            const search = this.searchStr.toLowerCase().trim()
            
            return this.currencies.filter(curr => {
                const code = curr.code ? curr.code.toLowerCase() : ''
                const name = curr.titles && curr.titles[this.lang_] ? curr.titles[this.lang_].toLowerCase() : ''
                const sign = curr.sign ? curr.sign.toLowerCase() : ''
                
                return code.includes(search) || name.includes(search) || sign.includes(search)
            })
        },
    },
    methods: {
        lang(value){ return this.$t(`views.transfer.${value}`)},
        async getClipboardData() {
            try {
                const text = await navigator.clipboard.readText();
                return text;
            } catch (err) {
                console.error('Failed to read clipboard contents:', err);
                return null;
            }
        },
        splitNum(num){
            return this.helper.split_num(num)
        },
        clear() {
            this.amount = null
        },
        past(type, min, max) {
            if (!type || (type !== 'send' && type !== 'receive')) return;
            this.getClipboardData().then((val) => {
                if (!val) return
                if(typeof val == 'string') val = val.replace(/[^0-9.]/g, '')
                let bVal = new BigNumber(val);
                let bMin = new BigNumber(min);
                let bMax = new BigNumber(max);
                if (bVal.isNaN()) return;
                if (bVal.isLessThan(0)) return;
                if (bVal.isEqualTo(0)) return;
                if (bVal.isLessThan(bMin)) bVal = bMin
                if (bVal.isGreaterThan(bMax)) bVal = bMax
                if (type === 'send') this.amount_send = bVal.toString()
                else if (type === 'receive') this.amount_receive = bVal.toString()
            });
        },
        getCurImage(cur){
            if(!cur || !cur.image) return ''
            return cur.image
        },
        getCurSign(cur){
            if(!cur || !cur.sign) return ''
            return cur.sign
        },
        openPopup() {
            if (this.disableSelect) return
            this.popup = true
        },
        setCurrency(curr){
            this.$emit('update:currency', curr)
            this.popup = false
        },
        setMin(){
            this.$emit('update:amount', this.min)
        },
        setMax(){
            this.$emit('update:amount', this.max)
        },
        goToRequest(){
            this.$emit('request')
            this.popup = false
        },
    },
    beforeCreate() {
        this.helper = new Helper()
    },
}
</script>